import { render, staticRenderFns } from "./page-list.vue?vue&type=template&id=140b62e9&scoped=true"
import script from "./page-list.vue?vue&type=script&lang=js"
export * from "./page-list.vue?vue&type=script&lang=js"
import style0 from "./page-list.vue?vue&type=style&index=0&id=140b62e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140b62e9",
  null
  
)

export default component.exports